import { useInfiniteQuery } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

interface IGetEmergencyProcedureListParams {
  pageParam: number;
  pageSize?: number;
  keyword?: string;
}

const getEmergencyProcedureList = async (values: IGetEmergencyProcedureListParams) => {
  const { pageParam, pageSize = 10, keyword = '' } = values;

  const { data } = await axiosClient.get(
    `/emergency-procedure?page_num=${pageParam}&page_size=${pageSize}&keyword=${keyword}`,
  );

  return {
    result: data,
    nextPage: pageParam + 1,
    isLast: !!data.next,
  };
};

const useGetEmergencyProcedureListQuery = (keyword?: string) =>
  useInfiniteQuery(
    ['emergencyProcedure', 'list', keyword],
    ({ pageParam = 1 }) => getEmergencyProcedureList({ pageParam, keyword }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.isLast) return lastPage.nextPage;
        return undefined;
      },
      onError: (error) => {
        console.error('get emergencyProcedure list error', error);
      },
    },
  );

export default useGetEmergencyProcedureListQuery;
